module.exports = __webpack_public_path__ + "0b252cf1d5797f7b78ab4ce669fb8c0d.MP3";